// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/InventoryOnHand.yaml
// Generated: 2026-03-11T13:04:50.029Z
// </auto-generated>

import { ReadOnlyEntityService } from '@/lib/EntityService';
import { InventoryOnHand } from '@/types/inventory/InventoryOnHand';

/**
 * InventoryOnHand Service (Read-Only)
 * Query operations for InventoryOnHand via the ABP API.
 */
export const inventoryOnHandService = new ReadOnlyEntityService<InventoryOnHand>(
  '/api/inventory/inventoryonhand',
  'InventoryOnHand',
);
